import createReactComponent from '../createReactComponent';
export default createReactComponent('minus-vertical', 'IconMinusVertical', [
  ['path', { d: 'M12 5v14', key: 'svg-0' }],
]);
